// extracted by mini-css-extract-plugin
export default {"read":"JumpButton_read__nTu1i","arrow":"JumpButton_arrow__DA696"};